module.exports = "<div class=\"alg-inpage-notification\">\n  <div class=\"icon\">\n      <img src=\"../../../../assets/images/icons/{{icon}}.svg\" alt=\"\">\n  </div>\n  <div class=\"content\">\n    Ciao\n    <span>{{ text }}</span>\n    <ng-content></ng-content>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/atoms/alg-inpage-notification/alg-inpage-notification.component.html
// module id = ./src/app/components/atoms/alg-inpage-notification/alg-inpage-notification.component.html
// module chunks = main